import Breadcrumb from "@/components/feature/Breadcrumb";
import { siteInfo } from "@/mocks/dramas";

export default function AboutIntro() {
  return (
    <section className="relative overflow-hidden border-b border-background-200/60">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Empty%20elegant%20dark%20cinema%20hall%20with%20rows%20of%20deep%20red%20velvet%20seats%20and%20a%20faintly%20glowing%20screen%20in%20the%20distance%2C%20warm%20amber%20ambient%20lighting%2C%20dramatic%20moody%20atmosphere%2C%20rich%20shadows%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=1600&height=800&seq=hl-about-hall&orientation=landscape"
          alt="深色影院放映厅，暗红丝绒座椅与微亮的银幕"
          className="h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/90 to-background-50"></div>
      </div>

      <div className="relative mx-auto max-w-page px-4 pb-14 pt-28 md:px-6 md:pt-36">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
          关于 {siteInfo.name}
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
          {siteInfo.name}是一个专注短剧内容发现与榜单整理的内容平台。我们把散落在各处的好剧整理成清晰的排行榜和同款推荐，
          让每一部作品都能被对的观众看见，也让每一次点开都尽量不踩雷。
        </p>

        <dl className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200/70 bg-background-100/60 px-4 py-5">
              <dt className="text-xs font-label text-foreground-600">{stat.label}</dt>
              <dd className="mt-2 font-heading text-xl font-bold text-accent-400 md:text-2xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}